import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import DatePicker from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";

import ErrorMsg from "../components/error-msg/error-msg";
import appStyles from "../../app.module.css";
import AppUtil from "../classes/util";
import Api from "../classes/api";
import AppConstants from "../classes/constants";

const exportContactsFormInitialValues = {
  data_type: AppConstants.EXPORT_CONTACTS_TYPES.CUSTOMER_DATA,
  start_date: undefined,
  end_date: undefined,
};

const exportContactsFormValidationSchema = Yup.object().shape({
  data_type: Yup.string().required("Please provide export type."),
  start_date: Yup.string().required("Please provide start date.").nullable(),
  end_date: Yup.string().required("Please provide end date.").nullable(),
});

const ExportContacts = () => {
  const [apiError, setApiError] = useState(null);

  const onSubmit = async (values, { setSubmitting }) => {
    try {
      const formData = new FormData();
      formData.append("action", "rsquote_export_data");
      formData.append("data_type", values.data_type);
      formData.append("start_date", values.start_date);
      formData.append("end_date", values.end_date);

      const apiSvc = await Api.getInstance();
      const res = await apiSvc.getExportContactsData(formData);
      window.open(res.data.data, "_blank");
    } catch (err) {
      setApiError(AppUtil.getErrorMessage(err));
    } finally {
      setSubmitting(false);
    }
  };

  const FormDatePicker = (props) => {
    return (
      <Field name={props.name}>
        {({ field, form: { setFieldValue } }) => {
          return (
            <DatePicker
              {...field}
              maxDate={new Date()}
              minDate={props.minDate}
              onChange={(val) => {
                setFieldValue(field.name, moment(val).format("YYYY-MM-DD"));
              }}
              dateFormat="yyyy-MM-dd"
            />
          );
        }}
      </Field>
    );
  };

  return (
    <div className={appStyles.rezziBlock}>
      <div className={appStyles.rezziBlockHeader}>
        <h2 className={appStyles.colorPrimary}>Export Contacts</h2>
      </div>
      <div className={appStyles.exportContactWrapper}>
        <Formik
          initialValues={exportContactsFormInitialValues}
          validationSchema={exportContactsFormValidationSchema}
          onSubmit={onSubmit}
          enableReinitialize={true}
        >
          {({ values, touched, isSubmitting, errors }) => (
            <Form>
              <div className={appStyles.formRadioContainer}>
                <span>Export Type</span>
                <div className={appStyles.formRow}>
                  <div className={`${appStyles.formField}`}>
                    <label className={appStyles.formRadioGroup}>
                      <Field
                        type="radio"
                        value={AppConstants.EXPORT_CONTACTS_TYPES.CUSTOMER_DATA}
                        name="data_type"
                      />
                      <span>Customer Data</span>
                    </label>
                  </div>
                </div>

                <div className={appStyles.formRow}>
                  <div className={`${appStyles.formField}`}>
                    <label className={appStyles.formRadioGroup}>
                      <Field
                        type="radio"
                        value={AppConstants.EXPORT_CONTACTS_TYPES.COMMON_DATA}
                        name="data_type"
                      />
                      <span>Quote Provided</span>
                    </label>
                    <ErrorMessage name="data_type" component={ErrorMsg} />
                  </div>
                </div>
              </div>

              <div className={appStyles.formRow}>
                <div
                  className={`${appStyles.formField} ${
                    values.start_date ? appStyles.hasValue : ""
                  } ${
                    touched.start_date && errors.start_date
                      ? appStyles.hasError
                      : ""
                  }`}
                >
                  <FormDatePicker
                    id="start_date"
                    name="start_date"
                    minDate={undefined}
                  />
                  <label htmlFor="start_date">Start Date</label>
                  <ErrorMessage name="start_date" component={ErrorMsg} />
                </div>

                <div
                  className={`${appStyles.formField} ${
                    values.end_date ? appStyles.hasValue : ""
                  } ${
                    touched.end_date && errors.end_date
                      ? appStyles.hasError
                      : ""
                  }`}
                >
                  <FormDatePicker
                    id="end_date"
                    name="end_date"
                    minDate={
                      values.start_date
                        ? new Date(values.start_date)
                        : new Date()
                    }
                  />
                  <label htmlFor="end_date">End Date</label>
                  <ErrorMessage name="end_date" component={ErrorMsg} />
                </div>
              </div>

              {apiError && (
                <div
                  className={`${appStyles.colorDanger} ${appStyles.textCenter}`}
                >
                  {apiError}
                </div>
              )}

              <button
                type="submit"
                className={`${appStyles.btnSubmit} ${
                  appStyles.hasButtonLoading
                } ${isSubmitting && appStyles.rezziButtonLoading}`}
                disabled={isSubmitting}
              >
                {isSubmitting && (
                  <div className={appStyles.rezziButtonLoader}></div>
                )}
                {!isSubmitting && "Export"}
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default ExportContacts;
